import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { FAQS } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ink-soft px-5 py-16 sm:px-8 sm:py-24" data-id="element-64" data-mp="1l9o6t8rmrzlq">
      <div className="mx-auto max-w-3xl" data-id="element-65" data-mp="1ge0kd14j9kjx">
        <div className="text-center" data-id="element-66" data-mp="2e0fxxrtu9y27">
          <SectionLabel data-id="element-67" data-mp="2dzem3l5017jf">Preguntas frecuentes</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-68" data-mp="291d3t2fedc90">
            ❓ Lo que más preguntan
          </h2>
        </div>

        <ul className="mt-12 space-y-3" data-id="element-69" data-mp="240yy3r19qee5">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="rounded-2xl border border-ink-line bg-ink" data-id="element-70" data-mp="smv2yhiy2k7i" data-mpi={index}>
                <h3 data-id="element-71" data-mp="skqrneipuix7">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-base font-bold text-white sm:text-lg" data-id="element-72" data-mp="nniha03t7j6i">
                    {faq.q}
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-violeta-400" aria-hidden="true" data-id="element-73" data-mp="ki1w5hg8o4cr" /> : <PlusIcon className="h-5 w-5 shrink-0 text-violeta-400" aria-hidden="true" data-id="element-74" data-mp="6pvhy0wnc7fy" />}
                  </button>
                </h3>
                {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-violeta-100/75" data-id="element-75" data-mp="3t07tg64ldk5a">{faq.a}</p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}